import BarometerLinkedin from './BarometerLinkedin'

export default BarometerLinkedin